import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import { TestID } from '../../../../utils/PropTypesDefinitions'

export type QualifierColors = 'GREEN' | 'LIGHTGREEN' | 'BLUE' | 'LIGHTBLUE' | 'YELLOW' | 'RED'

export type LeagueQualifierIndicatorProps = {
    /**
     * color of qualifier indicator
     * */
    color?: QualifierColors
} & TestID

const LeagueQualifierIndicator: FunctionComponent<LeagueQualifierIndicatorProps> = ({
    testID,
    color,
}) => (
    <Grid
        backgroundColor={color}
        testID={testID}
        width={4}
        minWidth={4}
        minHeight={44}
        noExpand
        marginRight={[2, 2, 3]}
    />
)

export default LeagueQualifierIndicator
